import { render } from "./programmes.html?vue&type=template&id=67a344d2&external"
import script from "./programmes.js?vue&type=script&lang=js&external"
export * from "./programmes.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__